import { FlagTriangleRight, Timer, UserRound } from "lucide-react";
import React from "react";
import Link from "next/link";
import { cn } from "@/lib/utils";
import { PCPS_EVENTS } from "@/lib/data/events";

const UpcomingEvents = () => {
  return (
    <section
      id="calander"
      className={cn(
        `xl:m-[2.5rem_auto_5rem] xl:float-none xl:max-w-[65.625rem]`,
        `md:m-[1.875rem_0] `,
        `m-[1.5625rem_0] p-[1.5rem_0] border-y border-y-[#272727]`
      )}
    >
      <div className={`xl:bg-white xl:m-auto`}>
        <div
          className={`
            xl:max-w-[90rem] xl:w-full
            md:w-[calc(100%_-_2.5rem)] m-auto bg-white max-w-full text-center`}
        >
          <header className={`mt-0`}>
            <h2
              className="font-bold text-[1.75rem] md:text-[2.25rem] m-0 text-center"
            >
              Upcoming Events
            </h2>
          </header>
          <div className={`text-left md:m-[1.5rem] m-[0_1.5rem] relative z-0`}>
            <div className={`md:flex-row flex-col justify-center list-none m-0 flex`}>
              {PCPS_EVENTS.slice(0, 3).map((item, itemIdx) => {
                return (
                  <article
                    key={item.title.toLowerCase().replace(/ /g, "-") + itemIdx}
                    itemScope
                    itemType="http://schema.org/Event"
                    className={`
                      basis-[33.2%] 
                      relative 
                      p-[1.25rem_0.9375rem] 
                      flex flex-col justify-end
                      ${itemIdx !== 2
                        ? "lg:border-r lg:border-b-0 border-b border-b-[#B1B1B1] lg:border-b-0 lg:border-r-[#B1B1B1]"
                        : ""
                      }
                    `}
                  >
                    <header className={`mt-0`}>
                      <div className={`flex `}>
                        <time
                          dateTime={item.date}
                          itemProp="startDate"
                          content={item.date}
                          className={`float-left clear-both w-auto mb-[0.4375rem]`}
                        >
                          <span
                            className={`font-bold text-[0.875rem] float-left
                                  leading-[1.125rem] tracking-[0.09375rem] text-[#A31F34] uppercase`}
                          >
                            {new Date(item.date).toLocaleString("en-US", {
                              month: "short",
                            })}
                          </span>
                          <span>&nbsp;</span>
                          <span
                            className={`font-bold text-[1.875rem] 
                                  leading-[1] text-[#A31F34] tracking-[0.125rem] float-left clear-both`}
                          >
                            {new Date(item.date).getDate()}
                          </span>
                        </time>
                        {
                          item.to_date && (
                            <>
                              <div className={cn(
                                `relative text-primary-red lowercase italic text-[0.75rem] leading-[1.875rem] m-[1.125rem_0.5rem_0]`
                              )}>to</div>

                              <time
                                dateTime={item.to_date}
                                itemProp="endDate"
                                content={item.to_date}
                                className={`float-left clear-both w-auto mb-[0.4375rem]`}
                              >
                                <span
                                  className={`font-bold text-[0.875rem] float-left
                                  leading-[1.125rem] tracking-[0.09375rem] text-[#A31F34] uppercase`}
                                >
                                  {new Date(item.to_date).toLocaleString("en-US", {
                                    month: "short",
                                  })}
                                </span>
                                <span>&nbsp;</span>
                                <span
                                  className={`font-bold text-[1.875rem] 
                                  leading-[1] text-[#A31F34] tracking-[0.125rem] float-left clear-both`}
                                >
                                  {new Date(item.to_date).getDate()}
                                </span>
                              </time>
                            </>
                          )
                        }
                      </div>

                      <p
                        className={`text-[1rem] leading-6 mb-[0.625rem] clear-both font-bold text-[#272727]`}
                      >
                        <span
                          itemProp="name"
                          className="text-[#272727] decoration-primary-red mt-0 underline"
                        >
                          {item.title}
                        </span>
                      </p>
                      {item.by && <p
                        className={`text-[0.875rem] leading-[1.43] font-medium text-[#272727] mb-0 mt-0 flex items-center justify-start`}
                      >
                        <UserRound className="size-[1rem] mr-[0.25rem] text-primary-red" />
                        {item.by}
                      </p>}
                      {item.venu && (
                        <p
                          itemProp="location"
                          itemScope
                          itemType="http://schema.org/Place"
                          className={`text-[0.875rem] leading-[1.43] font-medium text-[#272727] mb-0 mt-0 flex items-center justify-start`}
                        >
                          <FlagTriangleRight className="size-[1rem] mr-[0.25rem] text-primary-red" />
                          <span itemProp="name">{item.venu}</span>
                        </p>
                      )}
                      {item.time && <p
                        className={`text-[0.875rem] leading-[1.43] font-medium text-[#272727] mb-0 mt-0 flex items-center justify-start`}
                      >
                        <Timer className="size-[1rem] mr-[0.25rem] text-primary-red" />
                        {item.time}
                      </p>}
                    </header>
                  </article>
                );
              })}
            </div>
          </div>
          {/* TODO: NEED TO MODIFY */}
          <Link
            href={`/events`}
            className={`w-fit text-xs font-bold leading-[1.125rem] tracking-[0.0625rem] 
                                             [text-decoration:none] uppercase
                    border border-black border-2  p-[0.875rem_1.25rem] inline-block relative overflow-visible transition-[all_0.35s_ease-out]
                    after:content-[url(/svgs/longarrowright-red.svg)] after:text-[1.0625rem] after:pl-[0.3125rem] after:block after:float-right 
                    after:transition-[all_0.35s_ease-out] after:translate-y-[-0.125rem] hover:border-secondary-red hover:transition-[all_0.15s_ease]
                    after:hover:text-primary-red after:hover:translate-x-[0.625rem] after:hover:transition-[all_0.15s_ease]
                      hover:after:transition-[all_0.15s_ease]
                            hover:after:transform hover:after:translate-x-[0.625rem]
                            
                  `}
          >
            View Previous Events
          </Link>
        </div>
      </div>
    </section>
  );
};

export default UpcomingEvents;